module.exports = __webpack_public_path__ + "img/hone-content-text.db3aff9a.png";